/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateTimeCriteriaRangeOutput
 */
export interface DateTimeCriteriaRangeOutput {
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeCriteriaRangeOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeOutput
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeOutput
     */
    to?: Date;
}

export function DateTimeCriteriaRangeOutputFromJSON(json: any): DateTimeCriteriaRangeOutput {
    return DateTimeCriteriaRangeOutputFromJSONTyped(json, false);
}

export function DateTimeCriteriaRangeOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeCriteriaRangeOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
    };
}

export function DateTimeCriteriaRangeOutputToJSON(value?: DateTimeCriteriaRangeOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
    };
}


